// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g_OOV","textarea":"styles_textarea__1sW0X"};